<script lang="ts">
	import { Container, Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import { capFirstChar } from 'src/helpers/utilities';
	import CollapseGap from 'src/components/Utility/CollapseGap.svelte';

	export let visible = true;
</script>

<CollapseGap when={visible} marginBottom={null}>
	<Container padding="s" type="borderSolid" backgroundColor="color-base" class="mt-m">
		<Text styleType="h2" class="mb-s">
			{capFirstChar($format('settings_heading_physical_input', { default: 'Physical input' }))}
		</Text>
		<slot />
	</Container>
</CollapseGap>
